import { useCallback, useEffect, useState } from "react";
import { apiFetch } from "../lib/api";

interface ConversationItem {
  id: string;
  title: string | null;
  createdAt: string;
  updatedAt: string;
}

export function useConversations() {
  const [conversations, setConversations] = useState<ConversationItem[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await apiFetch("/api/conversations");
      if (res.ok) {
        setConversations((await res.json()) as ConversationItem[]);
      }
    } catch {
      // Sidebar is non-critical
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const create = useCallback(async (): Promise<string> => {
    const res = await apiFetch("/api/conversations", { method: "POST" });
    const { id } = (await res.json()) as { id: string };
    return id;
  }, []);

  return { conversations, loading, refresh, create };
}
